export default function Public({ children }) {

  return (
    <div className="h-screen bg-gray-50 overflow-hidden">
      {/* Narrow sidebar */}
      <div className="overflow-y-auto md:block">
        <div>
          <div className="w-full p-6 flex flex-col" style={{ backgroundColor: '#004469' }}>
            <div
              className="flex-shrink-0 flex items-center cursor-pointer"
            >
              <img
                className="h-8 w-auto"
                src={require('assets/images/logo_transparent_white.svg').default}
                alt="Xpertly"
              />
            </div>
          </div>

        </div>
      </div>

      {/* Content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Main content */}
        <div className="flex-1 flex items-stretch overflow-hidden">
          <main className="flex-1 overflow-y-auto">
            {/* Primary column */}
            <section
              aria-labelledby="primary-heading"
              className="min-w-0 flex-1 h-full flex flex-col overflow-scroll lg:order-last"
            >
              {children}
            </section>
          </main>
        </div>
      </div>
    </div>
  )
}